import styled from 'styled-components';

export const StyledActionButton = styled.button`
    outline: 0;
    border: 0;
    width: ${(props: any) => props.width || '310px'};
    min-height: 60px;
    background: ${(props: any) => props.bgColor};
    border: ${(props: any) => props.border || 'none'};
    border-radius: ${(props: any) => props.borderRadius || '0'};
    font-family: ${(props: any) => props.font || 'inherit'};
    margin-bottom: ${(props: any) => props.marginBottom || '0'};
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;

    img {
        height: 22px;
    }
` as any;
